var map = {
	"./documentos/documentos.module": [
		"./src/app/pages/documentos/documentos.module.ts",
		"common",
		"documentos.module"
	],
	"./estabelecimentos/estabelecimentos.module": [
		"./src/app/pages/estabelecimentos/estabelecimentos.module.ts",
		"common",
		"estabelecimentos.module"
	],
	"./notificacoes/notificacoes.module": [
		"./src/app/pages/notificacoes/notificacoes.module.ts",
		"common",
		"notificacoes.module"
	],
	"./relatorios/relatorios.module": [
		"./src/app/pages/relatorios/relatorios.module.ts",
		"common",
		"relatorios.module"
	],
	"./usuarios/usuarios.module": [
		"./src/app/pages/usuarios/usuarios.module.ts",
		"common",
		"usuarios.module"
	],
	"app/pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"common",
		"pages.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main